@if(component?.images?.length) {
<div class="flex flex-justify-center flex-column-m flex-column-s">
    <div class="w-12 p-l-6 p-r-6 p-l-0-s p-r-0-s p-t-10 p-b-10">
        <div [grid]="component.images.length"
             [gridColumnGap]="['15px','15px','40px','40px'][client.sizeId]">
            @for(item of component.images; track item){
            <div [gridColumn]="1">
                <df-image-wrapper class="overflow-hidden"
                                  style="border-radius: 12px;">
                    <img [dfImage]="item.image"
                         [ratio]="'4/5'">
                </df-image-wrapper>
                <p *iCms="'imageCaption' of item; skipEmpty: true"
                   class="c1 left m-t-2"></p>
            </div>
            }
        </div>
    </div>
</div>
}